// extracted by mini-css-extract-plugin
export default {"wrapper":"List__wrapper--BE9OM","button":"List__button--3mJAC","icon":"List__icon--2zEyR","text":"List__text--LX1HL","hiddenItem":"List__hiddenItem--nxxnq"};